import React from 'react';
import { Platform, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

type Props = {
  color?: string;
  marginHorizontal?: number;
  marginVertical?: number;
  style?: StyleProp<ViewStyle>;
};

export const SeparatorVertical: React.FC<Props> = ({
  color,
  marginHorizontal,
  marginVertical,
  style,
}) => (
  <View
    style={[
      {
        backgroundColor:
          color ||
          (Platform.OS === 'ios' ? 'rgba(0,0,0,.1)' : 'rgba(0,0,0,.04)'),
        width: Platform.OS === 'ios' ? StyleSheet.hairlineWidth : 1,
        marginHorizontal,
        marginVertical,
      },
      style,
    ]}
  />
);
